/**
 * HTML Templates Registry
 * 
 * This file contains metadata for all available HTML templates.
 * Each template entry defines:
 * - id: Unique identifier
 * - name: Display name
 * - description: Template description
 * - filePath: Path to the HTML file (relative to public folder)
 * - sections: List of sections in the template
 * - thumbnail: Optional preview image
 */

export interface HTMLTemplate {
  id: string;
  name: string;
  description: string;
  filePath: string;
  sections: string[];
  thumbnail?: string;
  category?: string;
  isDefault?: boolean;
}

export const HTML_TEMPLATES: HTMLTemplate[] = [
  {
    id: "html-template-1",
    name: "Choice Energy Template 1",
    description: "Tender Summary & Energy Cost Analysis template with teal gradient cover page and professional sections",
    filePath: "/templates/html/template-1.html",
    sections: [
      "Cover Page",
      "Logo Section", 
      "Introduction",
      "Two Column Layout",
      "Data Table",
      "Info Boxes",
      "Conclusion",
      "Contact Information"
    ],
    category: "tender",
    isDefault: true,
  },
  // Add more templates here as you create them
  // Example:
  // {
  //   id: "html-template-2",
  //   name: "Choice Energy Template 2",
  //   description: "Professional proposal template with modern design",
  //   filePath: "/templates/html/template-2.html",
  //   sections: ["Cover", "Executive Summary", "Pricing", "Terms"],
  //   category: "proposal",
  // },
];

/**
 * Get all HTML templates
 */
export function getAllHTMLTemplates(): HTMLTemplate[] {
  return HTML_TEMPLATES;
}

/**
 * Get HTML template by ID
 */
export function getHTMLTemplateById(id: string): HTMLTemplate | undefined {
  return HTML_TEMPLATES.find(template => template.id === id);
}

/**
 * Get HTML templates by category
 */
export function getHTMLTemplatesByCategory(category: string): HTMLTemplate[] {
  return HTML_TEMPLATES.filter(template => template.category === category);
}

/**
 * Get default HTML template
 */
export function getDefaultHTMLTemplate(): HTMLTemplate | undefined {
  return HTML_TEMPLATES.find(template => template.isDefault);
}

